import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kg',
  templateUrl: './kg.component.html',
  styleUrls: ['./kg.component.scss']
})
export class KgComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
